module.exports = __webpack_public_path__ + "static/media/snapshot-rendering.8820db39.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep15/snapshot-rendering.png
 ** module id = 214
 ** module chunks = 0
 **/